import React from "react";
import { WinStatus } from "@/lib/enum/winStatus";
import { Flex } from "@radix-ui/themes";
import { Text } from "@radix-ui/themes";
import { cn } from "@/lib/utils";
import { WinningStatus } from "@/lib/enum/winStatus";
import { LotLiveData } from "@/app/api/auctions/[auctionId]/gridData/route";

const LeadingBar = React.memo(
  ({
    winningStatus,
    polledData,
    className,
  }: {
    winningStatus?: WinningStatus;
    polledData: LotLiveData;
    className?: string;
  }) => {
    return winningStatus ? (
      <Flex
        justify="center"
        className={cn(
          "w-16 h-fit absolute bottom-1 right-1 text-xs px-1 py-0.5 rounded-xl shadow-lg",
          winningStatus?.winStatus === WinStatus.WINNING && "bg-[#BBDCA3]",
          winningStatus?.winStatus === WinStatus.OUTBID && "bg-[#EDCE8A]",
          className
        )}
      >
        <LeadingBarText polledData={polledData} winningStatus={winningStatus} />
      </Flex>
    ) : null;
  }
);
LeadingBar.displayName = "LeadingBar";

const LeadingBarText = React.memo(
  ({
    winningStatus,
    polledData,
  }: {
    winningStatus: WinningStatus;
    polledData: LotLiveData;
  }) => {
    switch (winningStatus?.winStatus) {
      case WinStatus.WINNING:
        return (
          <Text className="uppercase">
            {polledData.endDate && new Date(polledData.endDate).getTime() <= (new Date()).getTime()
              ? "WON"
              : "WINNING"}
          </Text>
        );
      case WinStatus.OUTBID:
        return <Text className="uppercase">OUTBID</Text>;
      default:
        return null;
    }
  }
);
LeadingBarText.displayName = "LeadingBarText";

export default LeadingBar;
